import { conditionMapTo7Ratings } from './conditionMapToText';

const conditionClassModifier = (condition, sevenRatings = false) =>
  sevenRatings
    ? `${conditionMapTo7Ratings(condition)?.toLowerCase().replace(/_/g, '-')}-v2`
    : condition?.toLowerCase().replace(/_/g, '-');

export default conditionClassModifier;
